import { Link } from "react-router-dom";
import { useLocale } from "@/i18n";
import logoSrc from "@/assets/logo.png";

interface LogoTextProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizeStyles = {
  sm: "h-10",
  md: "h-14",
  lg: "h-24",
};

const LogoText = ({ className = "", size = "md" }: LogoTextProps) => {
  const { localePath } = useLocale();

  return (
    <Link
      to={localePath("/")}
      className={`inline-block select-none ${className}`}
      aria-label="Employé Incognito — Accueil"
    >
      <img
        src={logoSrc}
        alt="Employé Incognito"
        className={`${sizeStyles[size]} w-auto object-contain`}
      />
    </Link>
  );
};

export default LogoText;
